module.exports = __webpack_public_path__ + "img/header-weddingRingsWaveDesign@2x.65de00b.webp";